type PublicPagesRootPath = '/public';
export const publicPagesRootPath: PublicPagesRootPath = '/public';

export const NotFoundPath: `/404` = '/404';
export const InternalServerErrorPath: `/500` = '/500';
export const GatewayTimeoutErrorPath: `/504` = '/504';
export const LogoutLandingPath: `/logout-landing` = '/logout-landing';
